(function () {
    'use strict';

    angular
        .module('HRConfirmationsControllers')
        .controller('HRConfirmationsPagingController', Controller);

    Controller.$inject = ['$scope'];

    function Controller($scope) {

        // Show More Matching And Exception Action?
        $scope.showMoreMatchingAndExceptionAction = function () {
            if ($scope.getFilteredMatchingAndExceptions().length <= $scope.ctrlCtxt.maxMatchingsAndExceptionsPerPage) {
                return false;
            }

            if ($scope.showMatchingAndExceptionPaging()) return false;

            return true;
        }

        // Show Matching And Exeption Pagin?
        $scope.showMatchingAndExceptionPaging = function () {
            return $scope.ctrlCtxt.showPaging;
        }

        // Show Confirm By Batch Action?
        $scope.showConfirmByBatchAction = function () {
            if (!$scope.ctrlCtxt.selectedFacetGroup) return false;
            if (!$scope.ctrlCtxt.selectedFacetGroup.matchingRule) return false;
            if (!$scope.ctrlCtxt.matchingsAndExceptions) return false;
            if (!$scope.ctrlCtxt.matchingsAndExceptions.length) return false;

            return $scope.ctrlCtxt.selectedFacetGroup.matchingRule.ConfirmByBatch;
        }

        // Show More Matchings And Exceptions
        $scope.showMoreMatchingsAndExceptions = function () {
            $scope.ctrlCtxt.showPaging = true;
            $scope.ctrlCtxt.matchingPaginationIdx      = 0;
            $scope.ctrlCtxt.matchingAndExceptionsPages = _.chunk($scope.getFilteredMatchingAndExceptions(), $scope.ctrlCtxt.maxMatchingsAndExceptionsPerPage);

            $scope.showNextMatchingsAndExceptionsPage();
        };

        // Is Previous Matchings And Exceptions Page Disabled?
        $scope.isPreviousMatchingsAndExceptionsPageDisabled = function () {
            return $scope.ctrlCtxt.matchingPaginationIdx === 0;
        };

        // Show Previous Matchings And Exceptions page
        $scope.showPreviousMatchingsAndExceptionsPage = function () {
            if ($scope.isPreviousMatchingsAndExceptionsPageDisabled()) return;

            $scope.ctrlCtxt.matchingPaginationIdx -= 1;
            $scope.ctrlCtxt.matchingsAndExceptions  = $scope.ctrlCtxt.matchingAndExceptionsPages[$scope.ctrlCtxt.matchingPaginationIdx];

            $scope.ctrlCtxt.matchingAndExceptionStartNb = $scope.ctrlCtxt.maxMatchingsAndExceptionsPerPage  * $scope.ctrlCtxt.matchingPaginationIdx + 1;
            $scope.ctrlCtxt.matchingAndExceptionEndNb = $scope.ctrlCtxt.matchingAndExceptionStartNb  + $scope.ctrlCtxt.matchingsAndExceptions .length - 1;
        };

        // Is Next Matchings And Exceptions Page Disabled?
        // Workaround for now => should have count from DB
        $scope.isNextMatchingsAndExceptionsPageDisabled = function () {
            return $scope.ctrlCtxt.matchingPaginationIdx === ($scope.ctrlCtxt.matchingAndExceptionsPages.length - 1);
        };

        // Show Next Matchings And Exceptions page
        $scope.showNextMatchingsAndExceptionsPage = function () {
            if ($scope.isNextMatchingsAndExceptionsPageDisabled()) return;

            $scope.ctrlCtxt.matchingPaginationIdx += 1;
            $scope.ctrlCtxt.matchingsAndExceptions  = $scope.ctrlCtxt.matchingAndExceptionsPages[$scope.ctrlCtxt.matchingPaginationIdx];

            $scope.ctrlCtxt.matchingAndExceptionStartNb  = $scope.ctrlCtxt.maxMatchingsAndExceptionsPerPage  * $scope.ctrlCtxt.matchingPaginationIdx + 1;
            $scope.ctrlCtxt.matchingAndExceptionEndNb = $scope.ctrlCtxt.matchingAndExceptionStartNb  + $scope.ctrlCtxt.matchingsAndExceptions .length - 1;
        };
    }
})();